import React, { Component } from 'react';
import SelectInput from '../selectInput';
import ReactGA from 'react-ga';
import { translate } from 'react-i18next';
import store from '../../store';
import { storeSelected } from '../../actions';
import { parse } from 'qs';


class EngineApplication extends Component {
  constructor(props) {
    super(props);
    const { application, selectedEngineOption } = this.props;
    const applications = application ? application.applications : [];
    let options = [];
    let title = '';
    let selected = selectedEngineOption || null;

    if (applications.length > 1) {
      title = applications[0].c_option_display;

      applications.map((element) => {
        return options.push({
          value: element.c_option,
          label: element.c_option,
        });
      });
    }

    this.state = {
      selected,
      options,
      title,
    };
  }

  // return the change intervals for the engine
  getOCI = (app) => {
    let text = '';
    const { t, equipment } = this.props;

    return equipment.change_interval
      .filter((i) => Number(i.application_id) === app.id)
      .map((x) => {
        if (x.intervals.length === 1) {
          text = x.intervals[0].value + x.intervals[0].unit;
        } else {
          text =
            x.intervals[0].value +
            x.intervals[0].unit +
            ' / ' +
            x.intervals[1].value +
            x.intervals[1].unit;
        }

        return (
          <p className="oci" key={x.application_id}>
            <span className="title">{t('vehicle_spec.oci')}</span>
            <span>{text}</span>
          </p>
        );
      });
  };

  getProductData = (gpn) => {
    const { equipment } = this.props;
    return equipment.products.find((product) => product.gpn === gpn);
  };

  // change transmission selection
  handleChange = (selected) => {
    this.setState({ selected: selected.value });
    store.dispatch(storeSelected(selected.value));
  };

  // Create select if multiple engine transmissions
  getSelectInput = (title, options) => {
    const { selected } = this.state;
    let selectedIndex = options.findIndex((element) => element.value === selected);
    const selectedOption = options[selectedIndex];

    ReactGA.event({
      category: this.props.i18n.language,
      action: this.props.selectedFamily,
      label: 'Engine Selection',
    });

    return (
      <SelectInput
        key={options.value}
        title={title}
        value={selectedOption}
        handleChange={this.handleChange}
        options={options}
      />
    );
  };

  render() {
    const { i18n, t, selectedFamily, application, showProductLinks } = this.props;
    const { title, selected, options } = this.state;
    const optionTitle = title.toLowerCase();
    const query = parse(window.location.search.replace('?', ''));
    const showBuyNow =
      query.buy !== 'false' && i18n.language !== 'fi' && i18n.language !== 'is' && showProductLinks;

    if (options.length && !selected) {
      return (
        <section className="engine">
          <div className="engine__header">
            <div className="engine__title">
              <p className="title">{t('result_page.engine')}:</p>
              <p className="instruction">
                {t('result_page.option').replace('#OPTION#', optionTitle)}
              </p>
            </div>
          </div>
          <div className="engine__filters">{this.getSelectInput('', options)}</div>
        </section>
      );
    }

    if (!application) {
      return (
        <section className="engine">
          <div className="engine__header">
            <div className="engine__title">
              <p className="title">{t('result_page.engine')}</p>
            </div>
          </div>
          <p>{t('result_page.no_product_available')}</p>
        </section>
      );
    } else {
      return application.applications.map((app) => {
        if (app.c_option === this.state.selected || application.applications.length === 1) {
          return (
            <section className="engine" key={app.name}>
              <div className="engine__header">
                <div className="engine__title">
                  <p className="title">{app.display_name}</p>
                  {this.props.equipment.change_interval ? this.getOCI(app) : ''}
                  {app.capacity ? (
                    <p className="display_capacity">
                      <span className="title">{t('vehicle_spec.capacity')}&nbsp;</span>
                      <span>{app.capacity + ' ' + this.props.equipment.model.capacity_unit}</span>
                    </p>
                  ) : (
                      ''
                    )}
                  {app.note_refs &&
                    <p className="note-ref">
                      <span className="title">{t('result_page.notes_ref')}&nbsp;</span>
                      {app.note_refs.map((note, index) => (
                        <span key={note['note_index']}>{`${note['note_index']}${app.note_refs.length !== index + 1 ? ', ' : ''} `}</span>
                      ))}
                    </p>
                  }
                </div>
                <div className="engine__filters">
                  {options.length ? this.getSelectInput(title, options) : ''}
                </div>
              </div>
              {app.products ? (
                app.products.map((product) => {
                  const productData = this.getProductData(product.gpn);
                  const details = productData.product_page_link || null;
                  const preferredPac = (productData.pacs && productData.pacs.find((pac) => pac.volume === '4L')) || null;
                  const fallbackPac = (productData.pacs && productData.pacs[0]) || (productData.default_image_url ? {img: productData.default_image_url} : null);
                  const pacShot = preferredPac ? preferredPac.img : fallbackPac && fallbackPac.img || null;

                 ReactGA.event({
                    category: i18n.language,
                    action: selectedFamily,
                    label: product.name,
                  });

                  return (
                    <div key={product.gpn} className="product">
                      {pacShot && <img src={pacShot} alt="product" class="product__image" />}
                      <div className="details">
                              <p className="product-name">{productData.name}</p>
                              {productData.short_description ?
                                  <div className="product__short-description" dangerouslySetInnerHTML={{ __html: productData.short_description }} /> : null}
                        {showBuyNow && productData.links && (
                          <div className="product__buynow">
                            <p>{t('result_page.buy_from_retailer')}</p>
                            <div className="product__links">
                              {productData.links.map((link) => (
                                <a
                                  href={link.url}
                                  target="_blank"
                                  onClick={() => {
                                    ReactGA.event({
                                      category: i18n.language,
                                      action: selectedFamily,
                                      label: `${product.name} - ${link.supplier}`,
                                    });
                                  }}
                                >
                                  <img src={link.img} />
                                </a>
                              ))}                         
                            </div>
                          </div>
                        )}

                        {query.details !== 'false' && details && showProductLinks && (
                          <a
                            className="button button--secondary"
                            href={details}
                            target="_blank"
                            onClick={() => {
                              ReactGA.event({
                                category: i18n.language,
                                action: selectedFamily,
                                label: product.name + ' Details',
                              });
                            }}
                          >
                            {t('result_page.details')}
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                  <p>{t('result_page.no_product_available')}</p>
                )}
            </section>
          );
        } else {
          return false;
        }
      });
    }
  }
}

export default translate('translations')(EngineApplication);



// WEBPACK FOOTER //
// ./src/components/results/EngineApplication.js